module.exports = __webpack_public_path__ + "img/avatar-star-icon.44d19173.svg";